import { render } from "./product-update.vue?vue&type=template&id=0f777c72"
import script from "./product-update.vue?vue&type=script&lang=js"
export * from "./product-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__